<template>
    <div style="height:100%" class="white">
        <table class="report-table white">

            <thead class="report-header">
                <tr>
                    <th class="print-only">
                        <!-- will print at the top of every page -->
                        <!-- this is a placeholder component - it is only here to give spacing on every printed page so that the actual site header has space - see: https://medium.com/@Idan_Co/the-ultimate-print-html-template-with-header-footer-568f415f6d2a -->
                        &nbsp;
                    </th>
                </tr>
            </thead>

            <tbody>
                <tr>
                    <td>
                        <v-progress-linear color="primary" indeterminate v-if="loading"></v-progress-linear>
                        <v-container v-else>
                            <v-row>
                                <v-col class="text-center">
                                    <span class="font-weight-bold text-h4">DAILY EXTRACTION {{ dailyExtractionSession.Barcode }}</span>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="6">
                                    <span class="font-weight-bold">Session Start:</span> {{ dailyExtractionSession.SessionStartTime | formatDate }}
                                </v-col>
                                <v-col cols="6">
                                    <span class="font-weight-bold">By:</span> {{ dailyExtractionSession.SessionStartUserEmail | formatUserName(dailyExtractionSession.SessionStartUserFirstName, dailyExtractionSession.SessionStartUserLastName) }}
                                </v-col>
                                <v-col cols="6">
                                    <span class="font-weight-bold">Session End:</span> {{ dailyExtractionSession.SessionEndTime | formatDate }}
                                </v-col>
                                <v-col cols="6">
                                    <span class="font-weight-bold">By:</span> {{ dailyExtractionSession.SessionEndUserEmail | formatUserName(dailyExtractionSession.SessionEndUserFirstName, dailyExtractionSession.SessionEndUserLastName) }}
                                </v-col>
                                <v-col cols="6">
                                    <span class="font-weight-bold">Venom Refrigerated At:</span> {{ dailyExtractionSession.VenomRefrigeratedTime | formatDate }}
                                </v-col>
                                <v-col cols="6">
                                    <span class="font-weight-bold">By:</span> {{ dailyExtractionSession.VenomRefrigeratedUser | formatUserName(dailyExtractionSession.VenomRefrigeratedUserFirstName, dailyExtractionSession.VenomRefrigeratedUserLastName) }}
                                </v-col>
                                <v-col cols="6">
                                    <span class="font-weight-bold">Species:</span> {{ dailyExtractionSession.SpeciesFullName }}
                                </v-col>
                                <v-col cols="6">
                                    <span class="font-weight-bold">Room:</span> {{ dailyExtractionSession.RoomName }}
                                </v-col>
                                <v-col cols="6">
                                    <span class="font-weight-bold">Rack:</span> {{ dailyExtractionSession.RackNumber }}
                                </v-col>
                                <v-col cols="6">
                                    <span class="font-weight-bold">Comment:</span> {{ dailyExtractionSession.Comment }}
                                </v-col>
                                <v-col cols="6">
                                    <span class="font-weight-bold">Included in Monthly Pool?:</span> {{ dailyExtractionSession.MonthlyPoolID ? "Yes" : "No" }}
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <span class="font-weight-bold text-h6">Specimen Records</span>
                                </v-col>
                                <v-col cols="12">
                                    <v-row no-gutters v-for="s in sessions" :key="s.DailyExtractionSessionEntryID">
                                        <v-col cols="6">
                                            <span class="font-weight-bold">Specimen ID:</span> {{ s.SpecimenDisplayID }}
                                        </v-col>
                                        <v-col cols="6">
                                            <span class="font-weight-bold">Geographical Location:</span> {{ s.GeographicalLocationName }}
                                        </v-col>
                                        <v-col cols="6">
                                            <span class="font-weight-bold">Recorded At:</span> {{ s.RecordedAt | formatDate }}
                                        </v-col>
                                        <v-col cols="12">
                                            <span class="font-weight-bold">Primary Extractor:</span> {{ s.PrimaryExtractorEmail | formatUserName(s.PrimaryExtractorUserFirstName, s.PrimaryExtractorUserLastName) }}
                                        </v-col>
                                        <v-col cols="12">
                                            <span class="font-weight-bold">Assistant Extractor:</span> {{ s.AssistantEmail | formatUserName(s.AssistantUserFirstName, s.AssistantUserLastName) }}
                                        </v-col>
                                        <v-col cols="6">
                                            <span class="font-weight-bold">Husbandry Performed:</span>
                                            <v-icon color="success" v-if="s.HusbandryPerformed">check</v-icon>
                                            <v-icon color="error" v-else>close</v-icon>
                                        </v-col>
                                        <v-col cols="6">
                                            <span class="font-weight-bold">Venom Collected:</span>
                                            <v-icon color="success" v-if="s.VenomCollected">check</v-icon>
                                            <v-icon color="error" v-else>close</v-icon>
                                        </v-col>
                                        <v-col cols="12">
                                            <span class="font-weight-bold">Collection Comment:</span>
                                            <p>{{ s.CollectionComment }}</p>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <span class="font-weight-bold text-h6">Venom Analysis</span>
                                    <PrintHistoricalAnalysis :venomAnalysis="venomAnalysis"></PrintHistoricalAnalysis>
                                </v-col>
                            </v-row>
                        </v-container>
                    </td>
                </tr>
            </tbody>

            <tfoot class="report-footer">
                <tr>
                    <td class="print-only">
                        <!-- will print at the bottom of every page -->
                        <!-- this is a placeholder component - it is only here to give spacing on every printed page so that the actual site footer has space - see: https://medium.com/@Idan_Co/the-ultimate-print-html-template-with-header-footer-568f415f6d2a -->
                        &nbsp;
                    </td>
                </tr>
            </tfoot>

            <!-- this will be fixed to the bottom of the page, and repeated on each printed page; to achieve the proper spacing, see: https://medium.com/@Idan_Co/the-ultimate-print-html-template-with-header-footer-568f415f6d2a -->
            <div class="print-footer-container print-only">
                Report generated by {{name}} at {{$moment().format($constants.DATE_FORMAT)}}
            </div>

        </table>
    </div>
</template>

<script>
import util from '@/helpers/util';
import moment from "moment";
import constants from "comunet-btg-utah-repository-shared/constants";
import * as venomPoolingAPI from "@/services/venomPoolingAPI";
import * as venomAnalysisAPI from '@/services/venomAnalysisAPI';

import PrintHistoricalAnalysis from '@/components/venomanalysis/PrintHistoricalAnalysis.vue';

export default {
    components: {
        PrintHistoricalAnalysis
    },
    props: {
        dailyExtractionSessionID: {
            type: [ Number, String ],
            default: null
        }
    },
    data() {
        return {
            loading: false,
            venomAnalysis: [],
            dailyExtractionSession: {},
            sessions: []
        }
    },
    computed: {
        name: function () {
            return util.getUserProfileNameFromUserObject(this.$store.state.authStore.user);
        }
    },
    async created() {
        this.loading = true;

        this.dailyExtractionSession = await venomPoolingAPI.getDailyExtractionSession({ dailyExtractionSessionID: this.dailyExtractionSessionID });
        this.sessions = await venomPoolingAPI.getDailyExtractionSessionEntries({ DailyExtractionSessionID: this.dailyExtractionSessionID });
        this.venomAnalysis = await venomAnalysisAPI.getHistoricalAnalysis(-1, this.dailyExtractionSessionID, -1, -1);

        this.loading = false;

        this.$nextTick(() => window.print());
    },
    filters: {
        formatDate: function (value) {
            if (!value) {
                return "";
            }

            var date = moment(value);
            if (date.isValid) {
                return date.format(constants.DATE_FORMAT);
            } else {
                return value;
            }
        },
        formatUserName(email, firstname, surname){
            
            if (!email){
                return "";
            }

            var desc = "";
            if (firstname && firstname != "") {
                desc = firstname;
            }

            if (surname && surname != "") {
                desc += (desc == "" ? "" : " ") + surname;
            }
            desc += (desc == "" ? "" : " (") + email + (desc == "" ? "" : ")")

            return desc;
        },
    }
}
</script>

<style lang="scss">
#app {
    .report-table {
        width: 100%;
    }

    // this is a placeholder - if it is needed then we'll need to change the height
    .report-header th {
        height: 0px;
    }

    .report-footer td, .print-footer-container {
        height: 50px; // this reserves space for the actual footer, see: https://medium.com/@Idan_Co/the-ultimate-print-html-template-with-header-footer-568f415f6d2a
    }

    .print-footer-container {
        position: fixed;
        bottom: 0px;
        width: 100%;
        text-align: center;
        color: var(--v-lightgray-base);
    }
}

@media print {
    #app {
        // shade every second row
        .v-data-table__wrapper table tr:nth-child(2n) {
            background-color: var(--v-lightgray-lighten1)
        }
    }
}
</style>